<template>
  <div>

    <h1> here is an h1 </h1>

    <h2> here is an h2 </h2>

    <p class="large">here is a large paragraph</p>

    <p>here is a regular paragraph</p>

  </div>


</template>

<style lang='scss'>

  @import '../styles/variables';



</style>

<script>

  import pages from './pages'
  import full_span_slide from '../components/organisms/full_span_slide'

  export default {
    data () {
      return {
      }
    },
    components: {
      ...pages,
      'full-span-slide': full_span_slide
    },
  }
</script>


// WEBPACK FOOTER //
// sandbox.vue?33bb32e4